export type ProfileResult = { token: string | null; loaded: boolean }

/** Outcome of the current-user request for the active session token. */
export type ProfileStatus = 'pending' | 'loaded' | 'failed'

/** Where the profile request stands for `token`. A result recorded under another token says nothing about it. */
export const getProfileStatus = (result: ProfileResult | null, token: string | null): ProfileStatus => {
	if (!result || result.token !== token) return 'pending'
	return result.loaded ? 'loaded' : 'failed'
}

/**
 * The result to record when a profile request ends. A profile already confirmed for this token stays
 * confirmed when a later request fails: the user it confirmed is still the best data there is, and
 * dropping it would close the blocking completion modal while the account is still incomplete.
 */
export const settleProfileResult = (
	previous: ProfileResult | null,
	token: string | null,
	loaded: boolean
): ProfileResult => ({ token, loaded: loaded || (previous?.token === token && previous.loaded) })
